import React from 'react'

const Keyword = () => {
    return (
        <div className='container' style={{marginBottom:30}}>
            <h1> Keywords in C</h1>
            <p>Keywords are predefined, reserved words in C language
                 and each of which is associated with specific features.
                  These words help us to use the functionality of C language. 
                  They have special meaning to the compilers.</p>
                  <table summary="List of all keywords used in C programming language." border="0">
	<thead>
		<tr>
			<th colspan="4">Keywords in C Programming</th>
		</tr>
	</thead>
	<tbody>
		<tr>
			<td>auto</td>
			<td>break</td>
			<td>case</td>
			<td>char</td>
		</tr>
		<tr>
			<td>const</td>
			<td>continue</td>
			<td>default</td>
			<td>do</td>
		</tr>
		<tr>
			<td>floatdouble</td>
			<td>else</td>
			<td>enum</td>
			<td>extern</td>
		</tr>
		<tr>
			<td>floatfloat</td>
			<td>or</td>
			<td>goto</td>
			<td>if</td>
		</tr>
		<tr>
			<td>int</td>
			<td>long</td>
			<td>register</td>
			<td>return</td>
		</tr>
		<tr>
			<td>short</td>
			<td>signed</td>
			<td>sizeof</td>
			<td>static</td>
		</tr>
		<tr>
			<td>struct</td>
			<td>switch</td>
			<td>typedef</td>
			<td>union</td>
		</tr>
		<tr>
			<td>unsigned</td>
			<td>void</td>
			<td>volatile</td>
			<td>while</td>
		</tr>
	</tbody>
</table>
<h3 >Decription of all keyword in C</h3>
<br /><br />
<h4>auto</h4>
The auto keyword declares automatic variables. For example:<br /><br />
<div className='containers'><code className='keywords'>auto int</code>  Noob1;</div>
This statement suggests that Noob1 is a variable of storage class auto and type int.

Variables declared within function bodies are automatic by default. They are recreated each time a function is executed.

Since automatic variables are local to a function, they are also called local variables. 
<hr />
<h4>break and continue</h4>
<p>The break statement terminates the innermost loop immediately when it's encountered.
     It's also used to terminate the switch statement.</p><br />
     The continue statement skips the statements after it inside the loop for the iteration.
     <div className='containers'>
    <p> 
        <code className='keywords'> for</code> (i=1;i &lt;=10;++i)&#123; <br />
        <code className='keywords'> if </code> (i==3) <br />
        <code className='library'> continue;</code>  <br />
        <code className='keywords'> if</code>  (i==7) <br />
        <code className='library'> break;</code>  <br />
        <code className='keywords'> printf</code> ("%d ",i); <br />
   &#125; 
</p>
     </div>
     <h4>Output:</h4>
     <div className='output'>1 2 4 5 6</div>
     <p>When i is equal to 3, the continue statement comes into effect and skips 3. When i is equal to 7, the break statement comes into effect and terminates the for loop. </p>
     <hr />
     <h4>switch, case and default</h4>
     <p>The switch and case statement is used when a block of statements has to be executed among many blocks. For example:</p> <br />
     <div className='containers'>
     <code className='library'>switch</code>(expression) <br />
     
     &#123;
     <code className='library'>case '1':</code><br />
     <code className='comment'>//some statements to execute when 1</code><br />
     <code className='keyword'>break;</code><br />
    <code className='library'>case '5':</code><br />
    <code className='comment'> //some statements to execute when 5</code><br />
    <code className='keywords'>break;</code><br />
    <code className='library'>default:</code><br />
    <code className='comment'>//some statements to execute when default;</code><br />
    &#125;
     </div>
     <hr />
     <h3>char</h3>
     <p>The char keyword declares a character variable. For example:</p> <br />
     <div className='containers'>
     char alphabet;
     </div><br />
     Here, alphabet is a character type variable
     <hr />
     <h3>const</h3>
     An identifier can be declared constant by using the const keyword.
     <div className='containers'>
         <code className='keywords'>const int</code>  a = 5;</div>
         <hr />
<h3>do...while</h3>
<div className='containers'>
    <code className='keywords'>int</code>  i; <br />
    <code className='keywords'>do </code><br />
    &#123;<br />
    <code className='library'> printf</code>("%d ",i);<br />
   i++;<br />
   &#125;<br />
   <code className='keywords'>while</code> (i&lt;10)</div><br />
   <h3>double and float</h3>
   <p>Keywords double and float are used for declaring floating type variables. For example:</p>
     <div className='containers'>
     <code className='keywords'> float</code> number; <br />
     <code className='keywords'>double</code> longNumber; <br />
     
     </div>
     Here, number is a single-precision floating type variable whereas, longNumber is a double-precision floating type variable. <br />
     <h3>if and else</h3>
     In C programming, if and else are used to make decisions.
    <div className='containers'>
    <code className='keywords'> if </code> (i == 1) <br />
    <code className='library'> printf</code>("i is 1.") <br />
    <code className='keywords'> else </code><br />
    <code className='library'> printf</code>("i is not 1.") <br />
   </div>
   <p>If the value of i is other than 1, the output will be :</p><br />
   <div className='output'>i is not 1</div>  
     <h3>enum</h3>
     Enumeration types are declared in C programming using keyword enum. For example: <br />
     <div className='containers'>
     <code className='keywords'> enum </code>suit <br />
     &#123;<br />
    hearts;<br />
    spades;<br />
    clubs;<br />
    diamonds;<br />
    &#125;;<br />
    </div>
    <p>Here, an enumerated variable suit is created having tags: hearts, spades, clubs, and diamonds.</p>
    <h3>extern</h3>
    <p>The extern keyword declares that a variable or a function has external linkage outside of the file it is declared.</p>
    <h3>for</h3>

    <p>There are three types of loops in C programming. The for loop is written in C programming using the keyword for. For example:</p><br />
    <div className='containers'>
    <code className='keywords'>for</code> (i=0; i&lt; 9;++i)&#123; <br />
    <code className='library'> printf</code>("%d ",i); <br />
  &#125;
  </div>
   <h4>Output</h4>
     <div className='output'>0 1 2 3 4 5 6 7 8</div>
     <hr />
     <h3>goto</h3>
     <p>The goto statement is used to transfer control of the program to the specified label. For example:</p><br />
     <div className='containers'>
     for(i=1; i&lt;5; ++i)
&#123;
<code className='keywords'>  if</code> (i==10) <br />
<code className='keywords'>  goto </code>error;<br />
    &#125;<br />
    <code className='library'>printf</code>("i is not 10");<br />
<code className='keywords'>error:</code><br />
<code className='library'>  printf</code>("Error, count cannot be 10.");<br />
    </div>
    <h5>Output</h5>
    <p>Error, count cannot be 10.</p> <br />
<hr />
<h3>int</h3>
The int keyword is used to declare integer type variables. For example:
<div className='containers'>
<code className='keywords'>int</code> count; <br />
</div>
Here, count is an integer variable.
<hr />
<h3>short, long, signed and unsigned</h3>
The short, long, signed and unsigned keywords are type modifiers that alter the meaning of a base data type to yield a new type. <br />
 <div className='containers'>
     <code>
     <code className='keywords'>short int smallInteger;</code> <br />
     <code className='keywords'>long int bigInteger</code>;<br />
     <code className='keywords'>signed int normalInteger</code>;<br />
     <code className='keywords'>unsigned int positiveInteger</code>;<br /></code>
 </div>
 <h3>return</h3>
The return keyword terminates the function and returns the value.
<div className='containers'>
<code className='keywords'>int</code> func() &#123; <br />
   <code className='keywords'> int </code> b = 5;<br />
  <code className='keywords'> return</code> b;<br />
&#125;
</div> 
<h3>sizeof</h3>
<div className='containers'>
The sizeof keyword evaluates the size of data (a variable or a constant).

<code class="library">#include &lt;stdio.h&gt;</code> <br />
<code className='keywords'> int</code> main() <br />
#&123;<br />
    <code className='keywords'>  printf</code>("%u bytes.",sizeof(char));<br />
#&125;
</div>
<h4>Output</h4> <br />
<div className='output'>1 bytes</div>

<h3>register</h3>
<p>The register keyword creates register variables which are much faster than normal variables.

</p>
<div className='containers'>
register int var1;
   </div>
   <h3>static</h3>
   <p>The static keyword creates a static variable. The value of the static variables persists until the end of the program. For example:</p>
   <div className='containers'>static int var;</div>
   <h3>struct</h3>
   <p>The struct keyword is used for declaring a structure. A structure can hold variables of different types under a single name.</p>
   <div className='containers'>
   <code className='keywords'>struct </code>student &#123; <br />
   <code className='keywords'> char </code>name[80];<br />
   <code className='keywords'> float </code>marks;<br />
   <code className='keywords'>int </code>age;<br />
&#125; s1, s2;</div>
  <h3>typedef</h3>
  <p>The typedef keyword is used to explicitly associate a type with an identifier.</p> <br />
  <div className='containers'>
  <code className='keywords'> typedef </code>float kg; <br />
      kg bear, tiger; <br />
  </div>
  <h3>union</h3>
  <p>A union is used for grouping different types of variables under a single name.</p> <br />
  <div className='containers'>
  <code className='keywords'> union </code> student &#123; <br />
    <code className='keywords'>  char </code>name[80];<br />
    <code className='keywords'>  float</code> marks;<br />
    <code className='keywords'>  int </code>age;<br />
&#125;<br />
  </div>
  <h3>void</h3>
  <p>The void keyword meaning nothing or no value.</p>
  <div className='containers'>
  <code className='keywords'>  void </code> testFunction( <code className='keywords'> int  </code>a)&#123; <br />
  .....
  &#125;
  </div>
  <p>Here, the testFunction() function cannot return a value because its return type is void.

</p>
<h3>volatile</h3>
<p>The volatile keyword is used for creating volatile objects. A volatile object can be modified in an unspecified way by the hardware</p>
<div className='containers'>
<code className='keywords'> const volatile</code> number
</div>
Here, number is a volatile object. <br />

Sincenumber is a constant, the program cannot change it. However, hardware can change it since it is a volatile object. <br /> <br /> <br />
</div>



    )
}

export default Keyword
